var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"back-login"},[_c('router-link',{staticClass:"back-link",attrs:{"to":"/login"}},[_c('a-icon',{attrs:{"type":"arrow-left"}}),_vm._v(" Voltar ao login ")],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }